import { useContext } from "react";
import { AppointmentCheckoutContext } from "../contexts/AppointmentCheckout";

export const useAppointmentCheckout = () => {
  const context = useContext(AppointmentCheckoutContext);
  return context;
};
